import gql from 'graphql-tag'

export default {
	data: () => ({
		glossary: []
	}),
	apollo: {
		glossary: {
			query: gql`{glossary { 
				id
				term
				definition
			}}`,
			update: data => data.glossary
		},
	},
	methods: {
		glossaryHydrate(text) {
			this.glossary.forEach(glosseryItem => {
				if (text.toLowerCase().includes(glosseryItem.term.toLowerCase())) {
					text = text.replace(glosseryItem.term,
						`<span class="c-glossary">
							<span class="c-glossary__term" onclick="this.parentElement.classList.toggle('c-glossary--active')">${glosseryItem.term}</span>
							<span class="c-glossary__definition">
								<button class="c-glossary__definition-close" onclick="this.parentElement.parentElement.classList.toggle('c-glossary--active')">
									<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1 1L13 14" stroke="#000" stroke-width="2" />
										<path d="M14 1L1 14" stroke="#000" stroke-width="2" />
									</svg>
								</button>
								${glosseryItem.definition}
							</span>
						</span>
					`)
					return true
				}
				return false
			})
			
			return text
		}
	}
}